/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React, { useEffect, useRef, useState } from 'react';

interface Props {
  wsUrl: string;
}

const PodLogStream: React.FC<Props> = ({ wsUrl }) => {
  const [lines, setLines] = useState<string[]>([]);
  const wsRef = useRef<WebSocket | null>(null);
  const preRef = useRef<HTMLPreElement | null>(null);

  useEffect(() => {
    setLines([]);
    const ws = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onmessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.type === 'log' && msg.data) {
          setLines((prev) => {
            const next = [...prev, msg.data as string];
            return next.length > 500 ? next.slice(-500) : next;
          });
        } else if (msg.type === 'end') {
          ws.close();
        }
      } catch {
        // non-JSON - treat as raw log line
        setLines((prev) => {
          const next = [...prev, e.data];
          return next.length > 500 ? next.slice(-500) : next;
        });
      }
    };

    ws.onerror = () => {};

    return () => ws.close();
  }, [wsUrl]);

  // Auto-scroll to bottom on new lines
  useEffect(() => {
    if (preRef.current) {
      preRef.current.scrollTop = preRef.current.scrollHeight;
    }
  }, [lines]);

  return (
    <pre
      ref={preRef}
      className="bg-black text-green-300 p-3 rounded h-96 overflow-auto text-xs whitespace-pre-wrap"
    >
      {lines.length === 0 ? (
        <span className="text-gray-500">Waiting for logs...</span>
      ) : (
        lines.join('\n')
      )}
    </pre>
  );
};

export default PodLogStream;
